
import { setActionStatusPending, setActionStatusSuccess, setActionStatusError } from '@/store/helpers';

import {
  SET_AVAILABLE_NODES,
  SET_AVAILABLE_TAGS,
  SET_AVAILABLE_TEMPLATES,
  SET_AVAILABLE_VOICES,
  SET_CALL_FLOW_TREES,
  SET_CALL_FLOW_TREE,
  SET_CALL_FLOW_TREE_REFERENCES,
  SET_CALL_FLOW_SCENE_ERRORS,
} from './mutationTypes';


/**
 * @type {import('vuex').MutationTree<typeof import('./state').default>}
 */
export default {
  setActionStatusPending,
  setActionStatusSuccess,
  setActionStatusError,
  [SET_AVAILABLE_NODES](state, availableNodes) {
    state.availableNodes = availableNodes;
  },
  [SET_AVAILABLE_TAGS](state, availableTags) {
    state.availableTags = availableTags;
  },
  [SET_AVAILABLE_TEMPLATES](state, availableTemplates) {
    state.availableTemplates = availableTemplates;
  },
  [SET_AVAILABLE_VOICES](state, availableVoices) {
    state.availableVoices = availableVoices;
  },
  [SET_CALL_FLOW_TREES](state, callFlowTrees) {
    state.callFlowTrees = callFlowTrees;
  },
  [SET_CALL_FLOW_TREE](state, callFlowTree) {
    state.callFlowTree = callFlowTree;
  },
  [SET_CALL_FLOW_TREE_REFERENCES](state, references) {
    state.callFlowTreeReferences = references;
  },
  [SET_CALL_FLOW_SCENE_ERRORS](state, sceneErrors) {
    state.sceneErrors = sceneErrors;
  },

  setBulkTagUploads(state, bulkTagUploads) {
    state.bulkTagUploads = bulkTagUploads;
  },

  setSearchedTagExistsInBulkTag(state, exists) {
    state.searchTagExists = exists;
  },

  setNewUploadedBulkTag(state, bulkTagId) {
    state.newUploadedBulkTagId = bulkTagId;
  },

  setNewTextToSpeechRecordingId(state, textToSpeechRecordingId) {
    state.newTextToSpeechRecordingId = textToSpeechRecordingId;
  },

  setNewTextToSpeechRecordingUrl(state, textToSpeechRecordingUrl) {
    state.newTextToSpeechRecordingUrl = textToSpeechRecordingUrl;
  },
  setIsDuplicate(state, isDuplicate) {
    state.isDuplicate = isDuplicate;
  },

  setUploadedFileName(state, fileName) {
    state.uploadedFileName = fileName;
  }
};
